import { useMemo } from 'react';
import { InputLabel } from '@mui/material';
import { mergeSxStyle } from '../../common/mergeSxStyle';
import { useInterstateTheme } from '../../InterstateThemeProvider';
import { inputLabelDefaultStyle } from './labelDefaultStyle';
import { formatLabel } from './formatLabel';
import { isFieldRequired } from '../../Validation';

/**
 * Base Label Input
 */
import { jsx as _jsx } from "react/jsx-runtime";
export const Label = props => {
  const {
    sx,
    id,
    className,
    required,
    displayLabel,
    label,
    size = 'medium',
    layout = 'vertical',
    alignment
  } = props;
  const theme = useInterstateTheme();
  const inputLabelStyle = useMemo(() => mergeSxStyle(inputLabelDefaultStyle(theme, size, layout, Boolean(displayLabel), alignment), sx), [theme, size, layout, displayLabel]);
  return displayLabel ? /*#__PURE__*/_jsx(InputLabel, {
    shrink: true,
    htmlFor: id || 'interstate-text-input',
    required: isFieldRequired(required),
    sx: inputLabelStyle,
    className: className,
    children: formatLabel(label, required)
  }) : null;
};